module.exports = __webpack_public_path__ + "img/Jump Casting102.5eb0acd3.jpg";